import { z } from 'zod';
export const apiErrorSchema = z.object({
    error: z.string(),
    message: z.string().optional(),
    request_id: z.string().optional(),
});
//# sourceMappingURL=http.js.map